/* eslint-disable jsx-a11y/alt-text */
import { Button, Form, message } from 'antd';
import { Formik } from 'formik';
import React, { memo, useCallback, useState } from 'react';
import styled from 'styled-components';
import * as yup from 'yup';
import { AuthApi, UserApi } from '../../apis';
import { useDispatch, useSelector } from 'react-redux';
import { delay } from '../../utils';
import useSWR from 'swr';
import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../navigation/type';
import { BlueButtonContainer } from '../../screens/home/home';
import { PinInput, ResendCode } from '../form/pin-input';
import { LockKeyhole } from 'lucide-react';
import { GeneralState, setForgotPassword } from '../../store/reducer/general';

const validationSchema = yup.object({
  otp: yup.string().min(3, 'Хэт богино байна').required('Нэвтэх нэр оруулна уу'),
});

const OtpForm = memo(() => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const { mutate } = useSWR('/api/user/me', UserApi.me);
  const navigate = useNavigate();
  const { forgot } = useSelector((state: { general: GeneralState }) => state.general);

  const onSubmit = useCallback(
    async (values: { otp?: string }) => {
      setLoading(true);
      try {
        await AuthApi.verify({
          username: forgot?.username,
          code: values?.otp,
        } as any);

        await delay(1000);

        navigate(NavigationRoutes.Password_Screen);

        setLoading(false);

        // const me = await UserApi.me();
        // mutate(me, false);
      } catch (error: any) {
        messageApi.open({
          type: 'error',
          content: error?.message,
        });
        setLoading(false);
      }
    },
    [forgot, messageApi, navigate]
  );

  const onResend = async () => {
    try {
      console.log('forgot?.username :', forgot?.username);
      const res = await AuthApi.otp({ username: forgot?.username } as any);
      dispatch(
        setForgotPassword({
          ...forgot,
          otp: res.message,
        })
      );
    } catch (error: any) {
      messageApi.open({
        type: 'error',
        content: error?.message,
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Container>
        <Formik initialValues={{ otp: '' }} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ handleSubmit, handleChange, values, errors, touched, setFieldValue }) => {
            return (
              <Form layout="vertical">
                <div className="card">
                  <div className="inputContainer">
                    <div className="w-full">
                      <img src={require('../../assets/ochun.png')} className="w-[220px]" />
                    </div>
                    <div className="h100" />

                    <div className="font-bold text-[16px] leading-[130%] tracking-[-0.01em] text-[#05041B] flex flex-1 justify-start w-full">
                      Баталгаажуулах
                    </div>

                    <div className="h-[12px]" />

                    <div className="font-normal text-[14px] leading-[130%] tracking-[-0.01em] text-[#4B4A49]">
                      Таны бүртгэлтэй мэйл хаягт илгээсэн кодыг доорх талбарт оруулна уу.{' '}
                      {forgot?.otp}
                    </div>

                    <div className="h-[24px]" />

                    <Form.Item className="w-[100%]">
                      <PinInput
                        length={6}
                        value={(values as any).otp}
                        onChange={(e) => {
                          setFieldValue('otp', e);
                          // if (e.length === 6) {
                          //   handleSubmit();
                          // }
                        }}
                      />
                    </Form.Item>

                    <div className="flex w-full">
                      <BlueButtonContainer className="w-full">
                        <Button
                          type="primary"
                          size="large"
                          className="w-full"
                          disabled={(values.otp || '')?.length !== 6}
                          loading={loading}
                          onClick={() => handleSubmit()}
                        >
                          Баталгаажуулах
                        </Button>
                      </BlueButtonContainer>
                    </div>
                    <div className="h-[20px]" />
                    <ResendCode onResend={onResend} />
                    <div className="h-[20px]" />
                    <div className="w-full h-[72px] rounded-[8px] bg-[#F5F6FA] opacity-100 flex flex-row justify-center items-center relative pl-[10px]">
                      <span className="text-center font-normal text-[14px] leading-[20px] tracking-[0px] text-[#4A5565] flex flex-row">
                        <LockKeyhole size={18} className="absolute left-[9px]" />
                        Таны аюулгүй байдлын төлөө бид 2 үе шаттай баталгаажуулалт ашигладаг.
                      </span>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Container>
    </>
  );
});

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  border: solid 1px black;
  justify-content: center;

  .title {
    font-weight: 700;
    font-size: 16px;
  }
  .card {
    border: solid 1px #eceaea;
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 18px;
  }
  .inputContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .logo {
    width: 180px;
  }
  .h100 {
    height: 30px;
  }
  .btn {
    width: 100%;
  }
`;

OtpForm.displayName = 'OtpForm';

export { OtpForm };
